import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Страница для формирования и работы с отчетом по контейнерам.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Отчеты",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1
    ]),
    _: 1
  }, 512))
}